<template>
    <div class="quiz-form__inner">
      <div class="quiz-input" :class="{'has-error': sendCodeError}">
        <label>Phone number</label>
        <input
          v-model="phone"
          v-maska="'+1 (###) ###-####'"
          placeholder="+1 (540) 999-9999"
          type="text"
          inputmode="tel"
          @input="$emit('input')"
          class="us-phone"
        >
        <div v-if="sendCodeError" class="quiz-input-error">
          Error sending SMS. Please try a different phone number.
        </div>
      </div>
      <div v-if="timer" class="quiz-resend">
        Request a new one in {{ timer }} sec
      </div>
      <button
        class="quiz-btn"
        type="button"
        :disabled="sendCodeDisable || phone.length < 17"
        @click="$emit('send', phone)"
      >
        Send code
      </button>
    </div>
</template>

<script>
import { vMaska } from 'maska/vue'

export default {
  emits: ['send', 'input'],
  directives: {
    maska: vMaska
  },
  props: {
    sendCodeDisable: Boolean,
    sendCodeError: Boolean,
    timer: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      phone: ''
    }
  }
}
</script>